import { VoidedObject } from "@/shared/models/voided-object.model";
import { Category } from "./Category";

export class DocumentDTO extends VoidedObject {
  _key?: string;
  fileName!: string;
  category!: Category;
  emailCreated?: string;
  emailChanged?: string;
  type!: string;
  documentPath?: string;
  documentPathSigned?: string;
  migrate?: boolean;
  userId?: string;
}
